export const SimulationsData = {
  data: [],
  meta: {
    current_page: 1,
    from: 1,
    last_page: 1,
    per_page: 15,
    total: 0
  },
  fields: [
    {
      key: "created_at",
      label: "Data",
      sortable: true,
      class: "w-auto"
    },
    {
      key: "full_name",
      label: "Cliente",
      sortable: true,
      class: "w-auto"
    },
    {
      key: "email",
      label: "Email",
      sortable: true,
      class: "w-auto"
    },
    {
      key: "export_file",
      label: "",
      sortable: false,
      class: "table-data-action"
    },
    {
      key: "uuid",
      label: "",
      sortable: false,
      class: "table-data-action"
    }
  ]
};
